<template lang="pug">
#bloco-evolucao-monitoramento-agricola
    h3(v-if="safra?.tipoSafra === 'SAFRA'") {{ $t('mensagens.monitoramentoAgricola.evolucaoColheita', {data_safra: dataSafra}) }}
    h3(v-else-if="safra?.tipoSafra === 'SAFRINHA'") {{ $t('mensagens.monitoramentoAgricola.evolucaoColheitaSafrinha', {data_safra: dataSafra}) }}

    div(v-if="exibirEvolucao == false" class="margem-progresso-opacity")
        .posicao-div
            div
                h3.fonte-cor {{ evolucaoArea.colhido }}
            div
                h3.fonte-cor {{ evolucaoArea.pendente }}
        progress.tamanho-progresso(
            :value='0',
            max='100'
        )
    div(v-else class="margem-progresso")
        .posicao-div
            div
                h3.fonte-cor {{ evolucaoArea.colhido }}
            div
                h3.fonte-cor {{ evolucaoArea.pendente }}
        progress.tamanho-progresso(
            :value='evolucaoArea.percentualColhido',
            max='100'
        )
    h3(v-show="exibirEvolucao == false" class="cultura-nao-selecionada") {{ $t('mensagens.monitoramentoAgricola.culturaNaoSelecionada') }}
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import UtilsService from './../../services/UtilsService';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'BlocoEvolucaoMonitoramentoAgricola',
    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters(['culturaFiltrada'])
    },

    props: {
        filtros: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            evolucaoArea: {
                colhido: this.$t('mensagens.monitoramentoAgricola.colhido'),
                pendente: this.$t('mensagens.monitoramentoAgricola.pendente')
            },
            exibirEvolucao: false,
            safra: {},
            dataSafra: ''
        };
    },

    watch: {
        filtros() {
            if (this.usuarioLogado) {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/agricola/calcular-evolucao-colheita`,
                    response => {
                        if (this.filtros.idCulturas.length > 0) {
                            this.evolucaoArea = JSON.parse(response);
                            this.exibirEvolucao = true;
                        } else {
                            this.exibirEvolucao = false;
                            this.resetEvolucao();
                        }
                    }
                );
            }
        }
    },
    beforeMount() {
        if (this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA) {
            this.evolucaoArea = {
                colhido: this.$t('mensagens.monitoramentoAgricola.colhido_ac'),
                pendente: this.$t('mensagens.monitoramentoAgricola.pendente_ac')
            };
        }
    },
    async mounted() {
        await connect();

        this.verificaSafra();

        if (this.culturaFiltrada) {
            this.exibirEvolucao = true;
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/agricola/calcular-evolucao-colheita`,
                    response => {
                        if (this.filtros.idCulturas.length > 0) {
                            this.evolucaoArea = JSON.parse(response);
                            this.exibirEvolucao = true;
                        } else {
                            this.exibirEvolucao = false;
                            this.resetEvolucao();
                        }
                    }
                );
        }
    },

    beforeDestroy() {
        disconnect();
    },

    methods: {
        async verificaSafra() {
            const safras = await UtilsService.getSafras();
            this.safra = safras.data.filter(safra => safra.vigente)[0];
            const anoSafra = this.safra ? this.safra.descricao.match(/\d{2}\/\d{2}/)[0] : null;
            this.dataSafra = anoSafra;
        },

        resetEvolucao() {
            if (this.usuarioLogado.paisGrupo === AmbientesEmpresas.NORTE_AMERICA) {
                this.evolucaoArea = {
                    colhido: this.$t('mensagens.monitoramentoAgricola.colhido_ac'),
                    pendente: this.$t('mensagens.monitoramentoAgricola.pendente_ac')
                };
                return;
            }
            this.evolucaoArea = {
                colhido: this.$t('mensagens.monitoramentoAgricola.colhido'),
                pendente: this.$t('mensagens.monitoramentoAgricola.pendente')
            };
        }
    }
};
</script>
<style lang="scss" scoped>
#bloco-evolucao-monitoramento-agricola {
    .margem-progresso {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .margem-progresso-opacity {
        padding-top: 10px;
        padding-bottom: 10px;
        opacity: 0.2;
    }

    .tamanho-progresso {
        height: 50px;
        width: -webkit-fill-available;
        background-color: var(--secondary-two);
        &::-webkit-progress-bar {
            background-color: var(--white);
        }
        &::-webkit-progress-value {
            background-color: var(--secondary-two);
        }
    }

    .posicao-div {
        display: flex;
        justify-content: space-between;
    }

    .fonte-cor {
        color: var(--primary);
    }

    .cultura-nao-selecionada {
        position: relative;
        padding-left: 45%;
        bottom: 50px;
    }
}
</style>
